import { Row, Col, Form, FormCheck } from "react-bootstrap";

const PlaylistsInProgramBreaks = ({
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked,
}) => {
  return (
    <>
      <Row className="align-items-center pt-2 ">
        <Col xs={3}>In Program Breaks: </Col>
        <Col>
          <Form.Select
            value={programDetails.inProgramBreaks.inProgramBreaks || ""}
            // xs="2"
            size="sm"
            id="inProgramBreaks"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                inProgramBreaks: {
                  ...programDetails.inProgramBreaks,
                  inProgramBreaks: e.target.value,
                  isDirty: true,
                },
              });
              setFormEdited(true);
            }}
            className={programDetails.inProgramBreaks.isDirty && "text-danger"}
            disabled={isLocked}
          >
            {[...Array(3).keys()].map((number) => (
              <option
                key={number}
                value={number}
              >
                {number === 0 ? "Zero" : number}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.inProgramBreaks.isDirty}
            id="inProgramBreaksisDirty"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                inProgramBreaks: {
                  ...programDetails.inProgramBreaks,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
    </>
  );
};
export default PlaylistsInProgramBreaks;
